export default __webpack_public_path__ + "static/media/logo-yay-red.b17fdfce.svg";